import baseService from './baseService';

export function GetPayrollTaxComputation(data){
    return baseService.post('/Company/GetPayrollTaxComputationsDataAsync',data);
}

export function MarkVendorReview(body){
    return baseService.post("/Company/PayRollTaxComputationMarkAsReview",body);
}